(() => {
  if (window.CozelioEyewear) return;
  const selectAustralianMarket = () => {
    const country = document.body.dataset.country;
    if (!country || country === 'AU' || document.body.dataset.designMode === 'true') return false;
    const form = document.getElementById('tm-localization');
    const select = form?.querySelector('[name="country_code"]');
    if (!select?.querySelector('option[value="AU"]')) return false;
    select.value = 'AU';
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
    }
    returnTo.value = location.pathname + location.search + location.hash;
    HTMLFormElement.prototype.submit.call(form);
    return true;
  };
  window.addEventListener('pageshow', event => { if (event.persisted) selectAustralianMarket(); });
  if (selectAustralianMarket()) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const imageSource = (src, width) => {
    const url = new URL(src, location.href);
    const previousWidth = Number(url.searchParams.get('width'));
    const previousHeight = Number(url.searchParams.get('height'));
    if (previousWidth > 0 && previousHeight > 0) url.searchParams.set('height', Math.round(previousHeight * width / previousWidth));
    url.searchParams.set('width', width);
    return url.toString();
  };
  const state = { busy: false, opener: null };
  const json = async response => {
    let data;
    try { data = await response.json(); } catch { throw new Error('The basket response could not be read.'); }
    if (!response.ok) throw Object.assign(new Error(data.description || data.message || 'The basket could not be updated.'), { known: response.status >= 400 && response.status < 500 && response.status !== 408 });
    return data;
  };
  const fetchCart = () => fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json);
  const giftConfig = () => {
    const source = Array.from(document.querySelectorAll('tm-product, #tm-cart-dialog')).find(el => el.dataset.productId && el.dataset.giftId);
    return source?.dataset;
  };
  const syncGifts = async cart => {
    const gifts = cart.items.filter(i => i.properties?._cozelio_bundle_gift === 'true');
    const config = giftConfig();
    const updates = {};
    const handled = new Set();
    for (const gift of gifts) {
      const productId = gift.properties._cozelio_bundle_product_id;
      if (!productId) continue;
      const quantity = handled.has(productId) ? 0 : Math.floor(cart.items.filter(i => String(i.product_id) === String(productId)).reduce((n, i) => n + i.quantity, 0) / 3);
      handled.add(productId);
      if (gift.quantity !== quantity) updates[gift.key] = quantity;
    }
    if (Object.keys(updates).length) cart = await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) }).then(json);
    if (config?.giftAvailable === 'true' && !handled.has(config.productId)) {
      const quantity = Math.floor(cart.items.filter(i => String(i.product_id) === config.productId).reduce((n, i) => n + i.quantity, 0) / 3);
      if (quantity > 0) {
        await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(config.giftId), quantity, properties: { _cozelio_bundle_gift: 'true', _cozelio_bundle_product_id: config.productId } }] }) }).then(json);
        cart = await fetchCart();
      }
    }
    return cart;
  };
  const visibleCount = cart => cart.items.filter(i => i.properties?._cozelio_bundle_gift !== 'true').reduce((n, i) => n + i.quantity, 0);
  const formatMoney = (cents, currency = 'AUD') => {
    const formatted = new Intl.NumberFormat('en-AU', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return currency === 'AUD' ? formatted.replace(/^\$/, 'A$') : formatted;
  };
  const setBusy = value => {
    state.busy = value;
    document.querySelectorAll('[data-checkout], [data-quantity]').forEach(button => { button.disabled = value || button.hasAttribute('data-minimum'); });
    document.querySelectorAll('tm-product').forEach(product => product.syncAvailability?.());
  };
  const setCount = count => document.querySelectorAll('[data-cart-count]').forEach(e => { e.textContent = count; e.hidden = count === 0; });
  const cartPageUrl = () => {
    const url = new URL(root() + 'cart', location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const readCartDialog = html => typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html').getElementById('tm-cart-dialog') : null;
  const loadCartDialog = async () => {
    const url = cartPageUrl();
    url.searchParams.set('sections', 'tm-cart-drawer');
    try {
      const payload = await fetch(url.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json);
      const dialog = readCartDialog(payload?.['tm-cart-drawer']);
      if (dialog) return dialog;
    } catch {}
    // A failed section render must not repeat the successful cart mutation.
    const response = await fetch(cartPageUrl().toString(), { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (response.ok) {
      const dialog = readCartDialog(await response.text());
      if (dialog) return dialog;
    }
    throw new Error('Your basket was updated. Open the basket page to see your items.');
  };
  const renderCart = async (cart, open = true) => {
    setCount(visibleCount(cart));
    const next = await loadCartDialog();
    const previous = document.getElementById('tm-cart-dialog');
    if (typeof next.showModal !== 'function') { location.assign(cartPageUrl().toString()); return; }
    const wasOpen = previous?.open;
    const opener = state.opener || document.activeElement;
    if (previous) { previous.close(); previous.replaceWith(next); } else document.body.append(next);
    if (wasOpen || open) { next.showModal(); state.opener = opener; }
  };
  class CozelioProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.abort = new AbortController();
      this.data = JSON.parse(this.querySelector('[data-colour-data]').textContent);
      this.slots = Array.from(this.querySelectorAll('[data-slot]'));
      this.uncertain = false;
      this.data.colours.forEach(c => {
        const variant = this.data.variants.find(v => v.id === c.id);
        c.available = this.dataset.live === 'true' && variant?.available === true;
        c.price = variant?.price ?? 9990;
      });
      this.slots.forEach((select, i) => {
        const options = Array.from(select.options);
        if (this.dataset.live === 'true') options.forEach(o => { o.disabled = !this.data.colours.find(c => c.id === o.value)?.available; });
        const available = options.filter(o => !o.disabled);
        if (available.length) select.value = available[i % available.length].value;
        select.addEventListener('change', () => { this.updateSlot(i); this.selectColour(select.selectedOptions[0].dataset.colour, false); this.updatePrices(); }, { signal: this.abort.signal });
        this.updateSlot(i);
      });
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-colour]');
        if (swatch?.tagName === 'BUTTON') this.selectColour(swatch.dataset.colour, true);
        const thumb = event.target.closest('[data-gallery-index]');
        if (thumb) this.showImage(Number(thumb.dataset.galleryIndex));
        if (event.target.closest('[data-gallery-prev]')) this.showImage(this.imageIndex - 1);
        if (event.target.closest('[data-gallery-next]')) this.showImage(this.imageIndex + 1);
        if (event.target.closest('[data-sticky-add]')) this.querySelector('form').requestSubmit();
      }, { signal: this.abort.signal });
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.addBundle(); }, { signal: this.abort.signal });
      this.onHistory = () => {
        const url = new URL(location.href);
        const colour = this.data.colours.find(c => c.id === url.searchParams.get('variant')) || this.data.colours.find(c => c.key === url.searchParams.get('colour')) || this.data.colours[0];
        this.selectColour(colour.key, true, false);
      };
      window.addEventListener('popstate', this.onHistory, { signal: this.abort.signal });
      this.onHistory();
      this.updatePrices();
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.querySelector('[data-sticky]').classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0 });
      this.observer.observe(this.querySelector('[data-add]'));
      this.syncAvailability();
      let start = null;
      const stage = this.querySelector('.tm-gallery-stage');
      stage.addEventListener('touchstart', e => { start = e.touches[0].clientX; }, { passive: true, signal: this.abort.signal });
      stage.addEventListener('touchend', e => { if (start !== null && Math.abs(e.changedTouches[0].clientX - start) > 45) this.showImage(this.imageIndex + (e.changedTouches[0].clientX < start ? 1 : -1)); start = null; }, { passive: true, signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialised = false; }
    updateSlot(i) {
      const colour = this.data.colours.find(c => c.id === this.slots[i].value);
      const image = this.querySelector(`[data-slot-image="${i}"]`);
      image.hidden = !colour?.image;
      if (colour?.image) { image.src = colour.image; image.alt = colour.name; } else image.removeAttribute('src');
    }
    selectColour(key, syncSlot = true, updateUrl = true) {
      const colour = this.data.colours.find(c => c.key === key);
      if (!colour) return;
      this.colour = colour;
      this.querySelector('[data-current-colour]').textContent = colour.name.toUpperCase();
      this.querySelectorAll('button[data-colour]').forEach(b => b.setAttribute('aria-pressed', b.dataset.colour === key ? 'true' : 'false'));
      if (syncSlot && (this.dataset.live !== 'true' || colour.available)) { this.slots[0].value = colour.id; this.updateSlot(0); }
      this.images = [];
      const galleryImage = colour.mainImage || colour.image;
      if (galleryImage) this.images.push({ src: galleryImage, alt: 'COZELIO PRO — ' + colour.name });
      this.data.slides.filter(s => s.src && (s.key === key || !s.key)).forEach(s => { if (!this.images.some(i => i.src === s.src)) this.images.push(s); });
      const thumbs = this.querySelector('.tm-gallery-thumbs');
      thumbs.replaceChildren();
      this.images.forEach((item, i) => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.galleryIndex = i;
        button.setAttribute('aria-label', `${this.data.labels.gallery}: ${colour.name}, ${i + 1} / ${this.images.length}`);
        const img = document.createElement('img'); img.src = imageSource(item.src, 200); img.alt = item.alt || colour.name; img.width = 72; img.height = 72; img.loading = 'lazy'; button.append(img); thumbs.append(button);
      });
      this.showImage(0);
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('colour', key); url.searchParams.set('variant', colour.id); history.pushState({ colour: key }, '', url); }
      this.updatePrices();
      this.syncAvailability();
    }
    showImage(index) {
      const image = this.querySelector('.tm-gallery-main');
      const empty = this.querySelector('.tm-gallery-empty');
      const count = this.images?.length || 0;
      image.hidden = count === 0; empty.hidden = count > 0;
      this.querySelectorAll('.tm-gallery-arrow').forEach(b => { b.hidden = count < 2; });
      if (!count) { image.removeAttribute('src'); image.removeAttribute('srcset'); return; }
      this.imageIndex = (index + count) % count;
      const item = this.images[this.imageIndex];
      image.style.objectFit = this.imageIndex === 0 ? 'cover' : 'contain';
      image.srcset = [400, 800, 1200, 1600].map(width => `${imageSource(item.src, width)} ${width}w`).join(', ');
      image.sizes = '(max-width:749px) 100vw, 50vw';
      image.src = item.src; image.alt = item.alt || this.colour.name;
      this.querySelectorAll('[data-gallery-index]').forEach((b, i) => b.setAttribute('aria-current', i === this.imageIndex ? 'true' : 'false'));
    }
    updatePrices() {
      if (!this.slots) return;
      const prices = this.slots.map(s => this.data.colours.find(c => c.id === s.value)?.price || 9990);
      const price = Math.max(...prices);
      this.querySelectorAll('[data-main-price], [data-bundle-price]').forEach(e => { e.textContent = formatMoney(price, this.dataset.currency || 'AUD'); });
      this.querySelector('.tm-bundle-top s').textContent = formatMoney(prices.reduce((a, b) => a + b, 0), this.dataset.currency || 'AUD');
      this.syncAvailability();
    }
    syncAvailability() {
      if (!this.data) return;
      const okay = this.dataset.live === 'true' && this.dataset.giftAvailable === 'true' && this.slots.every(s => this.data.colours.find(c => c.id === s.value)?.available);
      this.querySelectorAll('[data-add], [data-sticky-add]').forEach(b => { b.disabled = !okay || state.busy || this.uncertain; b.textContent = state.busy ? this.data.labels.adding : this.data.labels.add; });
    }
    async addBundle() {
      if (state.busy || this.uncertain || this.querySelector('[data-add]').disabled) return;
      const error = this.querySelector('[data-product-error]'); error.hidden = true;
      const recovery = this.querySelector('[data-cart-recover]'); recovery.hidden = true;
      const items = this.slots.map(s => ({ id: Number(s.value), quantity: 1 }));
      if (!items.every(i => Number.isSafeInteger(i.id))) return;
      if (this.dataset.giftId && this.dataset.giftAvailable === 'true') items.push({ id: Number(this.dataset.giftId), quantity: 1, properties: { _cozelio_bundle_gift: 'true', _cozelio_bundle_product_id: this.dataset.productId } });
      state.opener = this.querySelector('[data-add]');
      setBusy(true);
      let added = false;
      try {
        await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) }).then(json);
        added = true;
        const cart = await syncGifts(await fetchCart());
        await renderCart(cart);
      } catch (e) {
        if (!added && !e.known) { this.uncertain = true; try { const cart = await fetchCart(); await renderCart(cart); } catch {} }
        error.textContent = added ? 'Your items were added. Open your basket to continue.' : this.uncertain ? this.data.labels.uncertain : e.message || this.data.labels.failed;
        error.hidden = false; recovery.hidden = false;
      } finally { setBusy(false); }
    }
  }
  customElements.define('tm-product', CozelioProduct);
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener) { event.preventDefault(); if (state.busy) return; state.opener = opener; setBusy(true); try { const cart = await syncGifts(await fetchCart()); await renderCart(cart); } catch { location.assign(cartPageUrl().toString()); } finally { setBusy(false); } }
    const close = event.target.closest('[data-cart-close]');
    if (close) { document.getElementById('tm-cart-dialog')?.close(); state.opener?.focus?.(); }
    if (event.target.id === 'tm-cart-dialog') { const rect = event.target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) { event.target.close(); state.opener?.focus?.(); } }
    const quantity = event.target.closest('[data-quantity]');
    if (quantity && !quantity.disabled && !state.busy) {
      const key = quantity.closest('[data-line-key]').dataset.lineKey;
      const error = document.querySelector('[data-cart-error]');
      error.hidden = true; setBusy(true);
      try { const cart = await fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(quantity.dataset.quantity) }) }).then(json); await renderCart(await syncGifts(cart)); }
      catch (e) { const target = document.querySelector('[data-cart-error]'); target.textContent = e.message; target.hidden = false; }
      finally { setBusy(false); }
    }
    const more = event.target.closest('[data-more-reviews]');
    if (more) { more.closest('section').querySelectorAll('[data-extra-review]').forEach(e => { e.hidden = false; }); more.hidden = true; }
    const railControl = event.target.closest('[data-rail-prev], [data-rail-next]');
    if (railControl) { const rail = railControl.closest('.tm-community').querySelector('.tm-community-rail'); rail.scrollBy({ left: rail.clientWidth * .7 * (railControl.hasAttribute('data-rail-prev') ? -1 : 1), behavior: 'smooth' }); }
  });
  document.addEventListener('input', event => { if (event.target.matches('[data-compare-range]')) event.target.closest('.tm-compare-stage').style.setProperty('--split', event.target.value + '%'); });
  document.addEventListener('cancel', event => { if (event.target.id === 'tm-cart-dialog') state.opener?.focus?.(); }, true);
  document.addEventListener('submit', async event => {
    if (event.target.id === 'tm-localization') {
      let returnTo = event.target.querySelector('[name="return_to"]');
      if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; event.target.append(returnTo); }
      returnTo.value = location.pathname + location.search;
      return;
    }
    const form = event.target;
    if (!form.matches('[data-cart-checkout], [data-cart-page-form]')) return;
    event.preventDefault();
    if (state.busy) return;
    const checkout = form.hasAttribute('data-cart-checkout') || event.submitter?.name === 'checkout';
    setBusy(true);
    try {
      let cart;
      if (form.hasAttribute('data-cart-page-form')) {
        const updates = {};
        form.querySelectorAll('[data-update-key]').forEach(input => { updates[input.dataset.updateKey] = Math.max(0, Math.floor(Number(input.value) || 0)); });
        cart = await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) }).then(json);
      } else cart = await fetchCart();
      cart = await syncGifts(cart);
      if (!checkout) { location.reload(); return; }
      if (!cart.items.length) { await renderCart(cart); return; }
      const productId = giftConfig()?.productId;
      const pairs = cart.items.filter(item => String(item.product_id) === productId);
      if (pairs.length && cart.currency !== 'AUD') throw new Error('Choose Australia in the country selector to check out in AUD.');
      if (pairs.length) {
        const quantity = pairs.reduce((n, item) => n + item.quantity, 0);
        const total = pairs.reduce((n, item) => n + item.final_line_price, 0);
        const expected = (Math.floor(quantity / 3) + quantity % 3) * 9990;
        if (total !== expected) throw new Error('The offer could not be confirmed. Please refresh your basket before checking out.');
      }
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = '1'; form.append(input);
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      const target = document.querySelector('[data-cart-dialog-error]') || form.closest('dialog')?.querySelector('[data-cart-error]') || document.querySelector('[data-cart-page-error]');
      if (target) { target.textContent = error.message; target.hidden = false; }
    } finally { setBusy(false); }
  }, true);
  const tick = () => document.querySelectorAll('[data-deadline]').forEach(e => {
    const end = Date.parse(e.dataset.deadline);
    if (!Number.isFinite(end) || end <= Date.now()) { e.hidden = true; return; }
    const seconds = Math.floor((end - Date.now()) / 1000);
    e.querySelector('[data-countdown]').textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
  });
  tick(); if (document.querySelector('[data-deadline]')) setInterval(tick, 1000);
  window.CozelioEyewear = { fetchCart, renderCart, syncGifts, visibleCount, formatMoney, state };
})();


